import React from "react";

/**
 * Sample issue: an excerpt from a real-feeling brief, presented like a
 * long-form article column rather than a magazine cover. The point is to
 * let a visitor read the product before subscribing.
 */
export default function SampleIssue() {
    return (
        <section
            id="sample-issue"
            className="bt-section"
            data-testid="section-sample-issue"
            style={{
                borderTop: "1px solid var(--bt-rule)",
                backgroundColor: "var(--bt-paper-deep)",
            }}
        >
            <div className="bt-shell">
                <div
                    className="bt-promise-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 32,
                        marginBottom: 48,
                    }}
                >
                    <aside style={{ paddingTop: 14 }}>
                        <p className="signal" style={{ marginBottom: 14 }}>
                            № 04
                        </p>
                        <p className="marginalia" style={{ margin: 0, color: "var(--bt-mute)" }}>
                            From the brief
                        </p>
                    </aside>
                    <div className="bt-read">
                        <h2 className="t-display" style={{ margin: 0, marginBottom: 16 }}>
                            Read a page before you subscribe.
                        </h2>
                        <p className="t-lede" style={{ margin: 0 }}>
                            An excerpt from Issue No. 014, on the metal trade nobody
                            wants to put in writing. The brief never runs longer than
                            1,500 words. It is written for the reader, not the
                            algorithm.
                        </p>
                    </div>
                </div>

                <article
                    className="bt-read"
                    data-testid="sample-issue-card"
                    style={{
                        marginInline: "auto",
                        paddingTop: 28,
                        borderTop: "1px solid var(--bt-ink)",
                    }}
                >
                    <header style={{ marginBottom: 24 }}>
                        <p
                            className="marginalia"
                            style={{
                                margin: 0,
                                marginBottom: 12,
                                color: "var(--bt-mute)",
                            }}
                        >
                            Issue 14 &nbsp;·&nbsp; First Tuesday, October &nbsp;·&nbsp; Macro
                        </p>
                        <h3
                            className="t-display"
                            style={{
                                margin: 0,
                                fontSize: "clamp(30px, 3.4vw, 44px)",
                                lineHeight: 1.05,
                            }}
                        >
                            The quiet metal trade nobody&rsquo;s talking about.
                        </h3>
                    </header>

                    <p className="t-lede" style={{ margin: 0, marginBottom: 20 }}>
                        Foreign central banks bought 1,037 metric tons of gold last
                        year. That is the largest annual purchase in fifty-six years,
                        and it is the second straight year above a thousand tons. The
                        financial press wrote about it once, in a chart on page 12,
                        and moved on.
                    </p>

                    <p className="t-body" style={{ margin: 0, marginBottom: 20 }}>
                        Here is what that means in plain English. The people who move
                        money for a living, in the rooms where the actual decisions
                        get made, are quietly trading dollars for a metal that has
                        no yield, no earnings, and no story other than that it has
                        been money for four thousand years. They are not buying it
                        because they expect a crisis. They are buying it because
                        they expect a slow change.
                    </p>

                    <blockquote
                        style={{
                            margin: "32px 0",
                            paddingLeft: 24,
                            borderLeft: "2px solid var(--bt-ink)",
                            fontFamily: "Fraunces, serif",
                            fontVariationSettings: '"opsz" 60, "SOFT" 0',
                            fontStyle: "italic",
                            fontWeight: 400,
                            fontSize: "clamp(22px, 2.4vw, 30px)",
                            lineHeight: 1.3,
                            letterSpacing: "-0.01em",
                            color: "var(--bt-ink)",
                        }}
                    >
                        The slow change is the one that retirement playbooks were
                        never written for. It is the one ordinary savers rarely hear
                        about until it is finished.
                    </blockquote>

                    <p className="t-body" style={{ margin: 0, marginBottom: 24 }}>
                        Three things follow. First, the dollar is not going anywhere
                        soon, but it is doing less work than it did a decade ago.
                        Second, the assets that historically held value when reserve
                        currencies softened, gold being the obvious one, are being
                        accumulated by the institutions that would know. Third, none
                        of this is a reason to chase. It is a reason to be patient,
                        and to read carefully.
                    </p>

                    <p className="t-body" style={{ margin: 0, marginBottom: 28 }}>
                        This issue is about what to do, calmly, while the change is
                        still running. We will cover three concrete shifts a working
                        saver can make this quarter, what they cost, and what they
                        do not.
                    </p>

                    <hr className="hairline" style={{ marginBlock: 24 }} />

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 16,
                            flexWrap: "wrap",
                        }}
                    >
                        <p
                            className="marginalia"
                            style={{ margin: 0, color: "var(--bt-mute)" }}
                        >
                            Continued in the brief
                        </p>
                        <a
                            href="#recap"
                            className="arrow-link"
                            data-testid="sample-cta-subscribe"
                        >
                            Subscribe to read the rest
                        </a>
                    </div>
                </article>
            </div>
        </section>
    );
}
